import axios from 'axios';
import { KeyPress, DetectionConfig, AnalysisResult, ReplayAnalysisResult } from '../types';

const API_BASE = import.meta.env.VITE_API_URL || '/api';
const API_KEY = import.meta.env.VITE_API_KEY || '';

// Create axios instance with API key header
const apiClient = axios.create({
    baseURL: API_BASE,
    headers: {
        'X-Api-Key': API_KEY
    }
});

/**
 * Analyze keypress data from live testing mode.
 */
export async function analyzeLiveKeypresses(
    keypresses: KeyPress[],
    config: DetectionConfig
): Promise<AnalysisResult> {
    const response = await apiClient.post<AnalysisResult>('/analyze/live', {
        keypresses,
        config
    });
    return response.data;
}

/**
 * Upload and analyze an .osr replay file.
 */
export async function analyzeReplayFile(
    file: File,
    bpmThreshold: number,
    durationThreshold: number
): Promise<ReplayAnalysisResult> {
    const formData = new FormData();
    formData.append('replay', file);
    formData.append('bpmThreshold', bpmThreshold.toString());
    formData.append('durationThreshold', durationThreshold.toString());

    const response = await apiClient.post<ReplayAnalysisResult>(
        '/replay/upload',
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    );
    return response.data;
}

/**
 * Health check endpoint.
 */
export async function checkHealth(): Promise<{ status: string; timestamp: string }> {
    const response = await apiClient.get('/health');
    return response.data;
}